import { render, staticRenderFns } from "./ShopFilterContainer.vue?vue&type=template&id=3f668d6f"
import script from "./ShopFilterContainer.vue?vue&type=script&lang=js"
export * from "./ShopFilterContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports